import { render, staticRenderFns } from "./PzNaatForm.vue?vue&type=template&id=8446544c"
import script from "./PzNaatForm.vue?vue&type=script&lang=js"
export * from "./PzNaatForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8446544c')) {
      api.createRecord('8446544c', component.options)
    } else {
      api.reload('8446544c', component.options)
    }
    module.hot.accept("./PzNaatForm.vue?vue&type=template&id=8446544c", function () {
      api.rerender('8446544c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/DigitalSings/Naat/PzNaatForm.vue"
export default component.exports